import { type Margin } from "../types/Shared";

export const DEFAULT_COLOR_RANGE = ["#288bed", "rgb(218,232,249)"];
export const DEFAULT_MARGIN: Margin = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};
